import EmpresaService from '../../services/EmpresaService'

const state = {
  empresas: [],
  empresa: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 20
}

const getters = {
  empresas: state => state.empresas,
  empresa: state => state.empresa,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchEmpresas({ commit, state }, { page = 1, limit, filters = {} }) {
    try {
      const itemsPerPage = limit || state.itemsPerPage
      if (limit) {
        commit('setItemsPerPage', limit)
      }
      const response = await EmpresaService.getEmpresas(page, itemsPerPage, filters)
      commit('setEmpresas', response.data.data)
      commit('setTotalItems', response.data.total || 0)
      commit('setCurrentPage', page)
      return response
    } catch (error) {
      throw error
    }
  },

  async fetchEmpresa({ commit }, id) {
    try {
      const response = await EmpresaService.getEmpresa(id)
      commit('setEmpresa', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  },

  async createEmpresa({ commit }, empresa) {
    try {
      const response = await EmpresaService.createEmpresa(empresa)
      return response
    } catch (error) {
      throw error
    }
  },

  async updateEmpresa({ commit }, { id, empresa }) {
    try {
      const response = await EmpresaService.updateEmpresa(id, empresa)
      return response
    } catch (error) {
      throw error
    }
  },

  async deleteEmpresa({ commit }, id) {
    try {
      const response = await EmpresaService.deleteEmpresa(id)
      return response
    } catch (error) {
      throw error
    }
  },

  async exportarListado({ commit }, { formato, filtros }) {
    try {
      const response = await EmpresaService.exportarListado(formato, filtros)
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setEmpresas(state, empresas) {
    state.empresas = empresas
  },
  setEmpresa(state, empresa) {
    state.empresa = empresa
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}